import {
    ResourceManager,
    ComponentManager,
    LabelViewModel,
    ImageViewModel,
    ButtonViewModel,
    WindowViewModel,
    MessageBoxViewModel,
    LocatorHelper,
} from 'radpresentation.htmlclient.defaultviewextensions';
const locator = 'notice-message';
const windowLocator = 'window';
const imageLocator = 'content.image';
const labelLocator = 'content.label';

const headlineErgname = 'RADEM.RADEXTENSIONMANAGER.DELETECONFIRMATIONTITLE';
const captionErgname =
    'RADEM.RADEXTENSIONMANAGER.DELETEPROPERTYGROUPCONFIRMATION';

const imageSource = 'message_warning.png';
const yes = 'YES';
const no = 'NO';

class DeletePropertyGroupMessageBoxViewModel extends MessageBoxViewModel {
    public static yesCallback() {}

    public constructor(
        propertyGroupName: string,
        typeName: string,
        locator: KnockoutComputed<string>
    ) {
        let label = new LabelViewModel({
            parentLocator: locator,
            locator: LocatorHelper.buildLocator(locator, labelLocator),
            caption: ResourceManager.getInstance()
                .get(captionErgname)
                .replace('{0}', propertyGroupName)
                .replace('{1}', typeName),
        });

        let yesButton = new ButtonViewModel({
            label: LabelViewModel.create(yes),
            onClick: () => {
                this.window.isOpen(false);
                DeletePropertyGroupMessageBoxViewModel.yesCallback();
            },
            locator: LocatorHelper.buildLocator(locator, 'button.yes'),
        });

        let noButton = new ButtonViewModel({
            label: LabelViewModel.create(no),
            onClick: () => {
                this.window.isOpen(false);
            },
            locator: LocatorHelper.buildLocator(locator, 'button.no'),
        });

        let image = new ImageViewModel({
            parentLocator: locator,
            locator: LocatorHelper.buildLocator(locator, imageLocator),
            source: imageSource,
        });

        let window = new WindowViewModel({
            parentLocator: locator,
            locator: LocatorHelper.buildLocator(locator, windowLocator),
            width: 620,
            isModal: true,
            isOpen: true,
            allowClose: true,
            headline: new LabelViewModel({
                ergName: headlineErgname,
            }),
        });

        super({
            window: window,
            image: image,
            label: label,
            buttons: [yesButton, noButton],
        });
    }
}

export default DeletePropertyGroupMessageBoxViewModel;
ComponentManager.setViewModel(
    'DeletePropertyGroupMessageBoxViewModel',
    DeletePropertyGroupMessageBoxViewModel,
    'RADExtensionManagerHTMLViewExtension'
);
